import { createContext } from 'react';

// A context that is used by a stock item card to generate extra parameters for the download URL
export const StockDownloadContext = createContext<Record<string, string>>({});
